

import { UserPlus, Search, Gavel, Shield, Truck } from 'lucide-react'

const defaultIcons = [UserPlus, Search, Gavel, Shield, Truck]

export function StepByStepGuide({ registrationSteps = [], header = {} }) {
  // Helper: safely get string value from CMS object
  const getValue = (field, fallback = '') => {
    if (!field) return fallback
    if (typeof field === 'string') return field
    if (field && typeof field === 'object' && 'value' in field) {
      return field.value ?? fallback
    }
    return fallback
  }

  // Format API steps into clean array
  const steps = registrationSteps
    .map((step, index) => {
      const title = getValue(step.title)
      const subtitle = getValue(step.subtitle)
      const description = getValue(step.description)
      const imageUrl = getValue(step.imageUrl)

      // Skip empty steps
      if (!title && !subtitle && !description && !imageUrl) return null

      return {
        number: index + 1,
        icon: defaultIcons[index % defaultIcons.length],
        title: title || `Step ${index + 1}`,
        subtitle: subtitle || '',
        description: description || 'No description available.',
        imageUrl: imageUrl || '',
      }
    })
    .filter(Boolean) // remove skipped steps

  // If no valid steps → show friendly message
  if (steps.length === 0) {
    return null;
    // return (
    //   <section className="bg-bg-medium py-20">
    //     <div className="max-w-7xl mx-auto px-6 text-center">
    //       <h2 className="text-3xl font-bold text-white mb-6">
    //         {header.title || 'How It Works'}
    //       </h2>
    //       <p className="text-gray-400 text-lg max-w-2xl mx-auto">
    //         No registration steps available right now. Please check back later or contact support!
    //       </p>
    //     </div>
    //   </section>
    // )
  }

  return (
    <section className="bg-medium py-8 sm:py-12 lg:py-20 relative overflow-hidden">
      {/* Glow */}
      <div className="absolute top-1/2 left-[-10%] w-[500px] h-[500px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="mb-16 sm:mb-24 text-center">
          <h2 className="text-3xl lg:text-[32px] font-black text-white mb-4 tracking-tight">
            {header.title || 'How It Works'}
          </h2>
          {header?.description && (
            <div
              className="text-gray-400 text-lg max-w-3xl mx-auto leading-relaxed prose prose-invert prose-headings:text-white prose-strong:text-white"
              dangerouslySetInnerHTML={{ __html: header.description }}
            />
          )}
          <div className="w-16 h-1 bg-primary rounded-full mx-auto mt-6"></div>
        </div>

        {/* Steps */}
        <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-y-16 gap-x-8">
          {steps.length > 1 && (
            <div className="hidden lg:block absolute top-[44px] left-[10%] right-[10%] border-t-2 border-dotted border-white/10 z-0" />
          )}

          {steps.map((step) => {
            const Icon = step.icon
            return (
              <div key={step.number} className="relative z-10 flex flex-col items-center text-center group">
                <div className="relative w-24 h-24 bg-[#13191f] border border-white/10 rounded-[20px] flex items-center justify-center mb-10 transition-all duration-300 group-hover:border-primary/50 group-hover:bg-[#161d26]">
                  <Icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                  <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-black shadow-lg shadow-primary/40">
                    {step.number}
                  </div>
                </div>

                <h3 className="text-white font-bold text-lg mb-3 tracking-tight">
                  {step.title}
                </h3>

                {step.subtitle && (
                  <p className="text-primary text-sm font-medium mb-3">{step.subtitle}</p>
                )}

                <p className="text-gray-500 text-sm leading-relaxed font-medium px-2">
                  {step.description || "dfdf"}
                </p>

                {step.imageUrl && (
                  <div className="mt-6 w-full max-w-[180px] mx-auto">
                    <img
                      src={step.imageUrl}
                      alt={step.title}
                      className="w-full h-auto rounded-lg object-cover border border-white/10 shadow-md"
                    />
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}



